import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CaptchaService } from "../../../services/captcha.service";
import { ProductService } from "../../../../core/services/products.service";
import { I18nService } from "../../../services";
import { environment } from "../../../../../environments/environment";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";

@Component({
  selector: "app-exclusive-content-modal",
  templateUrl: "./exclusive-content-modal.component.html",
  styleUrls: ["./exclusive-content-modal.component.scss"]
})
export class ExclusiveContentModalComponent implements OnInit {
  form: FormGroup;
  imgCaptcha = "";
  textCaptcha = "";
  errorCaptcha = false;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.Brazil];

  industryOptions = [
    {
      value: "DEVELOPER",
      labelKey: "global.exclusiveModal.industries.developer"
    },
    {
      value: "CONSTRUCTION_ENGINEERING",
      labelKey: "global.exclusiveModal.industries.constructionEngineering"
    },
    {
      value: "INVESTOR_REAL_ESTATE_FUND",
      labelKey: "global.exclusiveModal.industries.investorRealEstateFund"
    },
    {
      value: "LOGISTICS_INDUSTRIAL",
      labelKey: "global.exclusiveModal.industries.logisticsIndustrial"
    },
    {
      value: "CORPORATE",
      labelKey: "global.exclusiveModal.industries.corporate"
    },
    {
      value: "ARCHITECTURE_DESIGN",
      labelKey: "global.exclusiveModal.industries.architectureDesign"
    },
    {
      value: "CONSULTANCY_BROKERAGE",
      labelKey: "global.exclusiveModal.industries.consultancyBrokerage"
    },
    {
      value: "ENERGY_SUSTAINABILITY",
      labelKey: "global.exclusiveModal.industries.energySustainability"
    },
    {
      value: "PROPTECH",
      labelKey: "global.exclusiveModal.industries.proptech"
    },
    { value: "OTHER", labelKey: "global.exclusiveModal.industries.other" }
  ];

  constructor(
    private fb: FormBuilder,
    private captchaService: CaptchaService,
    private productService: ProductService,
    private snackBar: MatSnackBar,
    private i18: I18nService,
    private dialogRef: MatDialogRef<ExclusiveContentModalComponent>
  ) {}

  get isBr(): boolean {
    return environment.platformId === "br";
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      ...(this.isBr
        ? {
            firstName: [""],
            lastName: [""],
            company: ["", Validators.required],
            industry: ["", Validators.required],
            phone: [null]
          }
        : {}),
      inputCaptcha: [""]
    });
    this.generateCaptcha();
  }

  generateCaptcha(): void {
    this.captchaService.generateCaptcha();
    this.imgCaptcha = this.captchaService.imgCaptcha;
    this.textCaptcha = this.captchaService.textCaptcha;
  }

  validateCaptcha(): boolean {
    this.errorCaptcha =
      this.form.get("inputCaptcha")?.value !== this.textCaptcha ||
      !this.form.get("inputCaptcha")?.value;
    return !this.errorCaptcha;
  }

  submit(): void {
    const message = this.i18.get("global.newsForm.message");
    const action = this.i18.get("global.newsForm.action");
    const errorMsj = this.i18.get("global.newsForm.errorMsj");
    this.validateCaptcha();
    if (this.form.valid && !this.errorCaptcha) {
      const payload = { ...this.form.value };
      if (payload.industry) {
        const opt = this.industryOptions.find(
          o => o.value === payload.industry
        );
        if (opt) payload.industry = this.i18.get(opt.labelKey);
      }
      this.productService.sendEmail(payload).subscribe(
        () => {
          this.snackBar.open(message, action);
          this.dialogRef.close();
        },
        () => {
          this.snackBar.open(errorMsj, action);
        }
      );
    }
  }
}
